import React from "react";

/**
 * Catches any uncaught render error in the React tree and shows
 * a friendly fallback instead of a blank white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="error-boundary">
        <div className="max-w-[560px] text-center">
          <div className="pg-overline mb-3" style={{ color: "#D97706" }}>Something broke</div>
          <h1 className="font-heading text-4xl font-extrabold tracking-tight">
            We hit an unexpected error<span style={{ color: "#002FA7" }}>.</span>
          </h1>
          <p className="text-sm text-[#52525b] mt-4 leading-relaxed">
            Our team has been notified. This is on us, not you. Try heading back
            to the home page - chances are everything's working there.
          </p>
          {this.state.error?.message && (
            <pre className="font-mono-pg text-[11px] text-left text-[#52525b] bg-[#f7f7f8] border border-[#e4e4e7] p-3 mt-6 overflow-auto max-h-32" data-testid="error-boundary-message">
              {this.state.error.message}
            </pre>
          )}
          <button
            onClick={this.handleReset}
            className="mt-6 bg-[#002FA7] text-white font-bold px-6 py-3 hover:bg-[#00207A]"
            data-testid="error-boundary-reset-btn"
          >
            Back to home
          </button>
        </div>
      </div>
    );
  }
}
